import Request from './request';

import { ApiResult, FlatFolderTagRow, OpMode } from '@controlrooms/models';

export interface FolderSearchPayload {
  top_folder?: number;
  ensemble_family_id?: string;
  start_time?: string;
  end_time?: string;
}

const SERVICE_ROOT = '/tag-explorer/api/v1';
const SERVICE_ROOT_V2 = '/tag-explorer/api/v2';

export const getFlatFolders = (
  payload: FolderSearchPayload,
): Promise<ApiResult<FlatFolderTagRow[]>> =>
  Request.post(`${SERVICE_ROOT_V2}/folders_with_tags`, payload, { timeout: 15000 });

export const getLatestBatch = (): Promise<ApiResult<{ timestamp: string | null }>> =>
  Request.post(`${SERVICE_ROOT}/latest`, {}, { timeout: 15000 });

export const getEarliestBatch = (): Promise<ApiResult<{ timestamp: string | null }>> =>
  Request.post(`${SERVICE_ROOT}/earliest`, {}, { timeout: 15000 });

export const getOpModes = (folderId: number): Promise<ApiResult<OpMode[]>> =>
  Request.get(`${SERVICE_ROOT_V2}/tags/op-modes/${folderId}`, { timeout: 15000 }).catch((err) => {
    console.error('error in getOpModes', err);
    return {
      result: [],
      request: {},
      headers: {},
    };
  });
